<div class="header-container fx-layout-row fx-justify-start fx-align-center fx-gap-10">
  @if (equipment) {
    <div class="equipment-name-block page-title">
      <div>{{ equipment?.toString() }}</div>
    </div>
  }

  <div class="fx-flex"></div>
  <workflow-buttons
    [entityType]="EntityType.EQUIPMENT"
    [view]="ManualWorkflowViewEnum.SHEET"
    [selectedEntityIds]="[equipment?.id]">
  </workflow-buttons>
  <div id="equipment-menu" class="fx-layout-row">
    <restricted-icon-button [class]="'mdi mdi-dots-vertical sm'" [id]="'equipment-sheet-menu-button'"
      [matMenuTriggerFor]="menu"
    [preconditions]="accessManager.hasAccess(Permission.VIEW_ASSET) || accessManager.hasAccess(Permission.DELETE_EQUIPMENT) || accessManager.hasAccess(Permission.CREATE_EQUIPMENT)"></restricted-icon-button>
    <mat-menu #menu="matMenu">
      <restricted-menu-item (onClick)="duplicateEquipment()" [id]="'duplicate-equipment-menu'"
        [permissions]="[Permission.CREATE_EQUIPMENT]"
        [preconditions]="true">
        {{ 'BUTTON.DUPLICATE' | translate }}
      </restricted-menu-item>
      <restricted-menu-item (onClick)="deleteEquipment()" [id]="'delete-equipment-menu'"
        [permissions]="[Permission.DELETE_EQUIPMENT]"
        [preconditions]="true">
        {{ 'BUTTON.DELETE_EQUIPMENT' | translate }}
      </restricted-menu-item>
      <restricted-menu-item (onClick)="showAssetSheet()" [id]="'show_asset_sheet_menu'"
        [permissions]="[Permission.VIEW_ASSET]" [preconditions]="true">
        {{ 'BUTTON.SHOW_ASSET_SHEET' | translate }}
      </restricted-menu-item>
    </mat-menu>
  </div>
</div>
